import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { EASE_REFINED } from './constants';

export default function FadeIn({
  children,
  delay = 0,
  y = 24,
  className = '',
  style = {},
  as = 'div',
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  const Component = motion[as] || motion.div;

  return (
    <Component
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: EASE_REFINED, delay }}
      style={style}
    >
      {children}
    </Component>
  );
}
